import { mountVueComponent } from '@/lib/mount-vue-component';

export default function() {
  import('@/lib/components/Shared/HelpIcon.vue').then(HelpIcon => {
    mountVueComponent('help-icon', HelpIcon);
  });
}
